import React from "react";
import { CheckCircle2, XCircle, Sparkles } from "lucide-react";
import Ad from "@/blog/Ad";

export const Callout = ({ children, kind = "info" }) => {
  const color =
    kind === "do"
      ? "border-emerald-500/30 bg-emerald-500/[0.06]"
      : kind === "dont"
      ? "border-rose-500/30 bg-rose-500/[0.06]"
      : "border-[#F09819]/30 bg-[#F09819]/[0.06]";
  const Icon =
    kind === "do" ? CheckCircle2 : kind === "dont" ? XCircle : Sparkles;
  const iconColor =
    kind === "do"
      ? "text-emerald-400"
      : kind === "dont"
      ? "text-rose-400"
      : "text-[#F09819]";
  return (
    <div className={`my-6 flex gap-3 rounded-2xl border p-5 ${color}`}>
      <Icon className={`h-5 w-5 shrink-0 ${iconColor}`} />
      <div className="text-sm text-white/85">{children}</div>
    </div>
  );
};

export const InlineCTA = ({ post, location, label, affiliateUrl, onTrack }) => (
  <>
    <div className="my-10 flex flex-col items-start gap-4 rounded-3xl border border-[#FF512F]/30 bg-gradient-to-r from-[#FF512F]/15 to-[#F09819]/10 p-8 sm:flex-row sm:items-center">
      <div className="flex-1">
        <div className="font-display text-xl font-bold">{label.title}</div>
        <div className="mt-1 text-sm text-white/65">{label.sub}</div>
      </div>
      <a
        data-testid={`blog-cta-${location}`}
        href={affiliateUrl}
        target="_blank"
        rel="sponsored noopener noreferrer"
        onClick={() => onTrack(location, post.slug)}
        className="group inline-flex items-center gap-2 rounded-full bg-gradient-to-r from-[#FF512F] to-[#F09819] px-6 py-3 text-sm font-semibold uppercase tracking-wider text-white shadow-[0_10px_40px_-10px_rgba(255,81,47,0.7)] transition-all hover:-translate-y-0.5"
      >
        {label.cta}
      </a>
    </div>
    <Ad slot="blog-post-mid" />
  </>
);

export const FaqBlock = ({ faq }) => (
  <>
    <h2 id="faq">Frequently asked questions</h2>
    {faq.map((f, i) => (
      <div key={i} className="my-5">
        <h3 className="!mb-1">{f.q}</h3>
        <p className="!mt-1 text-white/80">{f.a}</p>
      </div>
    ))}
  </>
);

export const Tldr = ({ children }) => (
  <Callout kind="info">
    <strong>TL;DR.</strong> {children}
  </Callout>
);
